import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { CrudService } from "./crud.service";
import { Billings } from "../models/billings";

@Injectable({
  providedIn: "root",
})
export class BillingsService extends CrudService<Billings, string> {
  protected _http: HttpClient;

  constructor() {
    const _http = inject(HttpClient);

    super(_http, `${environment.baseUrl}/billings`);

    this._http = _http;
  }

  nextNumber(year: number): Observable<{ number: number; year: number }> {
    return this._http.get<{ number: number; year: number }>(`${environment.baseUrl}/billings/next_number`, {
      params: { year },
    });
  }
}
